export default __webpack_public_path__ + "static/media/12-26.fffad717.jpeg";